// angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';

// others
import { AppService } from '../../app.service';
import { MeLoginService } from './me-login.service';
import { finalize, Subscription } from 'rxjs';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'me-login',
    templateUrl: './me-login.component.html',
    styleUrls: ['./me-login.component.scss'],
    providers: [MeLoginService]
})

export class MeLoginComponent implements OnInit, OnDestroy {
    data: any;
    language = this.translate.currentLang;
    subLanguage: Subscription;
    url = 'login';
    form: FormGroup;
    submitted: boolean;
    errorMessage = '';
    hidePassword = true;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public coreService: CoreService,
        public translate: TranslateService,
        public meLoginService: MeLoginService,
        public authService: AuthService,
        public router : Router
    ) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.pattern('[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}')]],
            password: ['', [Validators.required]]
        });

        this.getContent();
        this.subLanguage = this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    ngOnDestroy(){
        this.subLanguage.unsubscribe();
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }

    keyDownFunction(event) {
        if (event.keyCode === 13) {
            this.login(this.form.value, this.form.valid);
        }
    }

    login(form, isValid) {
        this.submitted = true;

        if (!isValid) {
            return;
        }

        this.appService.isLoading = true;

        this.meLoginService.login(form.email, form.password).pipe(
            finalize(() => {
                localStorage.removeItem('email');
                this.appService.isLoading = false;
            }))
            .subscribe(
            response => {
                this.authService.saveToLocalStorage(response['email'], response);
                this.appService.setLanguage(response['locale']);

                // Get clinic config
                this.appService.callApiGetClinicConfig(response['clinic_id']).subscribe(res => {
                    this.appService.storeMeClinicFolder(res);
                    this.router.navigate(['/me/dashboard']);
                });
            },
            error => {
                this.errorMessage = error.error.error;
            });
    }
}
